import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';

import { Select } from '@ubisend/pulse-components';

const SectionSelect = ({ value, onChange, ...props }) => {
  const [options, setOptions] = useState(null);

  const { data, isSuccess } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  useEffect(() => {
    if (isSuccess) {
      const options = data.data.map(imprt => {
        return {
          label: imprt.name,
          options: imprt.sections.map(section => {
            return {
              label: section.content.name,
              value: section.unique_id
            };
          })
        };
      });

      setOptions(options);
    }
  }, [data, isSuccess]);

  const formattedValue = useMemo(() => {
    if (!options || !value) {
      return null;
    }

    const option = options.find(group => {
      return group.options.find(option => option.value === value);
    });

    if (!option) {
      return null;
    }

    return option.options.find(option => option.value === value);
  }, [options, value]);

  return (
    <Select
      {...props}
      onChange={onChange}
      isLoading={!options}
      value={formattedValue}
      options={options ? options : []}
    />
  );
};

SectionSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default SectionSelect;
